import styled from "styled-components";

// export const Containner = styled.div`
// display: flex;
// flex-direction: column;
// gap: 1rem;
// color: green;
// font-weight: bold;
// display: flex;
//     flex-direction: column;
//     background: ${({ theme }) => theme.grayLight};
//     overflow-y: auto;
//     padding: 0 8px;
// `;

export const Title = styled.h6`
	font-weight: bold;
`;

export const Container = styled.div`
	display: flex;
	flex-direction: column;
	gap: 1rem;
	background: ${({ theme }) => theme.pantone656C};
	padding: 1rem;
	border-radius: 8px;
	width: 100%;
`;

export const AreaButtons = styled.div`
	display: flex;
	justify-content: center;
	gap: 1rem;
`;

export const AreaInputNumber = styled.div`
	position: relative;
`;

export const AreaCheckbox = styled.div`
	position: absolute;
	top: 14px;
	right: 0.6rem;
	margin: 0;

	.MuiFormControlLabel-root {
		margin: 0;
	}

	.MuiCheckbox-root {
		padding: 0;
	}

	.MuiCheckbox-colorSecondary.Mui-checked {
		color: #fab01c;
	}
`;
